import { render } from "./bills.vue?vue&type=template&id=16cfb8bb"
import script from "./bills.vue?vue&type=script&lang=js"
export * from "./bills.vue?vue&type=script&lang=js"

import "./bills.vue?vue&type=style&index=0&id=16cfb8bb&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__